import { styled } from '@mui/material/styles';
import { swipeAnimationZIndex } from 'src/utils/zIndexConstants';

export const SwipeAnimation = styled('div')({
  position: 'fixed',
  left: 0,
  bottom: -50,
  top: -50,
  width: 0,
  zIndex: swipeAnimationZIndex,
  borderRadius: '50%',
  backgroundColor: '#29434e',
});
